/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ plan: NonNullable<unknown> }} Report_Line_Seat_PlainInputs */



/**
* | output |
* | --- |
* | "{plan} seat" |
*
* @param {Report_Line_Seat_PlainInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const report_line_seat_plain = /** @type {((inputs: Report_Line_Seat_PlainInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Report_Line_Seat_PlainInputs, { locale?: "en" | "de" }, {}>} */ ((i, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ (`${i?.plan}-Platz`)
	return /** @type {LocalizedString} */ (`${i?.plan} seat`)
});